export default "__VITE_ASSET__CXNGUSYZ__"